import {ReactNode} from "react";
import {BoxProps, HStack, Text, VStack} from "@chakra-ui/react";
import {FaCheck, FaCheckDouble, FaRegClock} from "react-icons/fa";

type Props = {
    children?: ReactNode
    content: string
    subtitle: string
    sent: boolean
    status: string
};

function StatusIcon(p: {value: string}) {
    if (p.value === "pending") {
        return <FaRegClock
            data-cy="message-pending-indicator"
            size={12}
            color="#DEEBF5"
        />;
    }
    if (p.value === "sent") {
        return <FaCheck data-cy="message-sent-indicator" size={12} color="#DEEBF5"/> ;
    }
    if (p.value === "read") {
        return <FaCheckDouble
            data-cy="message-read-indicator"
            size={12}
            color="#8BCEF7"
        />;
    }
    return <></>;

}

function MessageBubble(p: Props & BoxProps) {
    return <VStack
        id={p.id}
        data-cy={p.id}
        position="relative"
        align={p.sent ? "flex-end" : "flex-start"}
        alignSelf={p.sent ? "flex-end" : "flex-start"}
        bg={p.sent ? "primary.500" : "gray.300"}
        color={p.sent ? "white" : "black"}
        px={4}
        py={2}
        borderRadius="lg"
        borderTopLeftRadius={p.sent ? "lg" : 0}
        borderBottomRightRadius={p.sent ? 0 : "lg"}
        maxW={{base: "65%", md: "55%"}}
    >
        <Text whiteSpace="pre-wrap" maxW="100%" style={{textWrap: "pretty"}}>{p.content}</Text>
        <HStack spacing={1} alignSelf="flex-end" userSelect="none">
            <Text fontSize="12px">{p.subtitle}</Text>
            {p.sent && <StatusIcon value={p.status}/>}
        </HStack>
    </VStack>;
}
export default MessageBubble;
